<template>
  <router-view :formData.sync="formData"></router-view>
</template>

<script>
export default {
  data () {
    return {
      formData: {
        kki_nm: '',
        kki_nm_ryksh: '',
        ksh_cd: null,
        set_bsh: '',
        nuny_dt: null
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/templates/KkiMstr/KkiMstrSnkTurkPrnt.vue